export default "__VITE_ASSET__a1249119__"